<template>
    <section class="g-wrapper">
        <header-com />
        <div style="width:100%;height:50px"></div>
         <iframe :src="link" :style="'border: 0;width:100%;overflow: scroll;height:'+height+'px'"></iframe>
    </section>
</template>

<script>
	export default {
		name: "agreement",
        data() {
		    return {
                active:1,
                type:'one',
                link:'',
                link1:location.origin+'/order/newShare/user.html',
                link2:location.origin+'/order/newShare/bzsq.pdf',
                link3:location.origin+'/order/newShare/bzsh.pdf',
                height:window.screen.height - 50
            }
        },
        beforeRouteLeave(to,from,next) {
            document.title = '包拯'
		    next()
        },
        created() {
            this.type = this.$route.query.type;
            if ( this.type == 'one' ){
                this.link = this.link3
                document.title = '包拯售后政策'
            } else if(this.type == 'two'){
                this.link = this.link2
                document.title = '包拯售前免责条款'
            }else{
                this.link = this.link1
                document.title = '包拯用户协议'
            }
        }
	}
</script>


<style scoped lang="scss">
    
</style>
